/**
 * Route wrapper for the admin Consultations list (mounted inside AppShell under
 * the admin/staff RequireAuth guard). `?preview=1` injects sample data + the
 * mock seam for QA before the callables deploy; otherwise it uses the live
 * listener + team-auth callables and degrades honestly.
 */
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ConsultationsAdmin from './ConsultationsAdmin';
import { makeMockConsultAdminApi } from '../lib/consultAdminApi';
import { sampleConsultations } from './sampleConsultations';

export default function ConsultationsAdminRoute() {
  const [sp] = useSearchParams();
  const preview = sp.get('preview') === '1';
  const mock = useMemo(() => (preview ? makeMockConsultAdminApi() : undefined), [preview]);
  const sample = useMemo(() => (preview ? sampleConsultations() : undefined), [preview]);
  return <ConsultationsAdmin apiOverride={mock} sampleFeed={sample} />;
}
